/**
 * @file Contributor dashboard UI — pages/Dashboard/Contributor/SubmittedDataset/ContributorSubmittedDatasetDetailView.tsx.
 */

import React, { useEffect, useState } from "react";
import axiosClient from "../../../../api/axiosClient";
import SubmissionDetailLayout from "../../../../components/submission/SubmissionDetailLayout";
import "../../Admin/Materials/SubmissionDetail/AdminSubmissionDetail.css";

interface Props {
  submissionId: string;
  onBack: () => void;
}

const ContributorSubmittedDatasetDetailView: React.FC<Props> = ({
  submissionId,
  onBack,
}) => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      try {
        const res = await axiosClient.get(`/submissions/${submissionId}`, {
          params: { includeFormFields: "true" },
        });
        if (!cancelled && res.data?.success) {
          setData(res.data.data);
        } else if (!cancelled) {
          setData(null);
        }
      } catch (err) {
        console.error("Failed to load dataset", err);
        if (!cancelled) setData(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    void load();
    return () => {
      cancelled = true;
    };
  }, [submissionId]);

  if (loading) {
    return (
      <div className="submitted-container">
        <div className="admin-detail-head">
          <button
            type="button"
            className="back-btn"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onBack();
            }}
          >
            ← Back
          </button>
        </div>
        <div className="admin-loading" style={{ padding: "3rem" }}>
          Loading dataset…
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="submitted-container">
        <div className="admin-detail-head">
          <button
            type="button"
            className="back-btn"
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onBack();
            }}
          >
            ← Back
          </button>
        </div>
        <div className="admin-empty" style={{ padding: "3rem" }}>
          Dataset not found
        </div>
      </div>
    );
  }

  return (
    <SubmissionDetailLayout
      bannerTitle="Submitted Dataset Details"
      submission={data}
      onBack={onBack}
      showReviewFlagHistory={false}
      showReviewStatus={false}
    />
  );
};

/** React component — Contributor Submitted Dataset Detail View. */
export default ContributorSubmittedDatasetDetailView;
